export default "/_next/static/images/Industrial-8d76223a640d5ee856727de8d66d11cc.png";